// Single funnel for cart attributes: one cart/update.js request, shared by every
// add-to-cart path in the theme.

function deskQuizPdpOrigin() {
  try {
    return sessionStorage.getItem('deskQuizPdpOrigin') === '1';
  } catch (e) {
    return false;
  }
}

function deskQuizStored(key) {
  try {
    return sessionStorage.getItem(key) || '';
  } catch (e) {
    return '';
  }
}

function deskQuizStoredFlow() {
  try {
    return (JSON.parse(sessionStorage.getItem('deskQuizAnswers')) || {})['step-flow'] || '';
  } catch (e) {
    return '';
  }
}

function deskQuizConsentDeclined() {
  var privacy = window.Shopify && window.Shopify.customerPrivacy;

  if (!privacy || !privacy.analyticsProcessingAllowed) return false;

  return privacy.analyticsProcessingAllowed() !== true;
}

function deskQuizTrackOptionsCart() {
  var config = window.deskQuizTrack || {};
  var session = deskQuizConsentDeclined() ? '' : deskQuizStored('deskQuizSession');
  var payload;
  var body;

  if (!config.url || config.screen) return;

  payload = {
    shop: config.shop || '',
    events: [{ t: 'view', screen: 'options_cart', step: 0, flow: deskQuizStoredFlow(), q: '', value: '' }],
  };

  if (session) payload.session = session;
  else payload.anon = 1;

  body = JSON.stringify(payload);

  try {
    if (navigator.sendBeacon && navigator.sendBeacon(config.url, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
  } catch (e) {}

  fetch(config.url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
    body: body,
    keepalive: true,
  }).catch(function () {});
}

function deskSetCartAttributes(extra) {
  var attributes = {};
  var pending = false;

  if (extra) {
    Object.keys(extra).forEach(function (key) {
      attributes[key] = extra[key];
      pending = true;
    });
  }

  // set by the quiz when the shopper leaves for a product page
  if (deskQuizPdpOrigin()) {
    attributes['Quiz product page'] = 'Yes';
    pending = true;
    deskQuizTrackOptionsCart();
  }

  if (!pending) return Promise.resolve(null);

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  return fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('cart/update.js responded ' + response.status);
      return true;
    })
    .catch(function () {
      return null;
    });
}

window.deskSetCartAttributes = deskSetCartAttributes;
